export default __webpack_public_path__ + "static/media/zBege.71e2fab8.png";